import { ChatText, Robot } from "@phosphor-icons/react";
import type { AIConditionDetails, ExtractedFieldAIDetails, CalculationAppliedDetails } from "../types";
import { Calculator } from "@phosphor-icons/react";

interface AIDetailsPanelProps {
  aiDetails: AIConditionDetails | ExtractedFieldAIDetails;
  variant?: 'condition' | 'field';
  calculationApplied?: CalculationAppliedDetails;
}

export function AIDetailsPanel({ aiDetails, variant = 'condition', calculationApplied }: AIDetailsPanelProps) {
  const bgColor = variant === 'condition' ? 'bg-violet-50' : 'bg-white';
  const borderColor = variant === 'condition' ? 'border-violet-200' : 'border-blue-200';
  const labelColor = variant === 'condition' ? 'text-violet-700' : 'text-blue-700';

  return (
    <div className={`mt-1.5 p-2 ${bgColor} rounded border ${borderColor} space-y-2`}>
      {/* Calculation details (if rule was applied) */}
      {calculationApplied && (
        <div className="p-1.5 bg-emerald-50 rounded border border-emerald-200">
          <p className="text-[9px] font-medium text-emerald-700 flex items-center gap-1">
            <Calculator className="h-3 w-3" />
            Berekeningsregel toegepast:
          </p>
          <div className="mt-1 text-[9px] text-emerald-800 space-y-0.5">
            <div><strong>Regel:</strong> {calculationApplied.rule}</div>
            <div><strong>Basiswaarde:</strong> {new Date(calculationApplied.baseValue).toLocaleDateString('nl-BE')}</div>
            <div><strong>Resultaat:</strong> {new Date(calculationApplied.result).toLocaleDateString('nl-BE')}</div>
            {calculationApplied.conditionDetails && (
              <div><strong>Voorwaarden:</strong> {calculationApplied.conditionDetails}</div>
            )}
          </div>
        </div>
      )}

      <div>
        <p className={`text-[9px] font-medium ${labelColor} flex items-center gap-1`}>
          <ChatText className="h-3 w-3" />
          {variant === 'condition' ? 'Gestelde vraag:' : 'Gebruikte prompt:'}
        </p>
        <pre className="mt-0.5 text-[9px] text-neutral-600 bg-white p-1.5 rounded overflow-auto max-h-20 whitespace-pre-wrap">
          {aiDetails.promptUsed}
        </pre>
      </div>
      <div>
        <p className={`text-[9px] font-medium ${labelColor} flex items-center gap-1`}>
          <Robot className="h-3 w-3" />
          AI antwoord ({aiDetails.model}):
        </p>
        <pre className="mt-0.5 text-[9px] text-neutral-600 bg-white p-1.5 rounded overflow-auto max-h-20 whitespace-pre-wrap">
          {aiDetails.rawResponse}
        </pre>
      </div>
      {/* Condition-specific: interpretation */}
      {'interpretedAs' in aiDetails && aiDetails.interpretedAs && (
        <div className="text-[9px] text-neutral-500">
          Geïnterpreteerd als: <span className={`font-medium ${
            aiDetails.interpretedAs === 'yes' ? 'text-green-600' :
            aiDetails.interpretedAs === 'no' ? 'text-red-600' :
            'text-amber-600'
          }`}>
            {aiDetails.interpretedAs === 'yes' ? 'Ja (voorwaarde voldaan)' :
             aiDetails.interpretedAs === 'no' ? 'Nee (voorwaarde niet voldaan)' :
             'Onduidelijk'}
          </span>
        </div>
      )}
    </div>
  );
}
